import { call } from 'redux-saga/effects';
import {
  getAddresses as getAddressesBit,
  getHorizontalAddresses as getHorizontalAddressesBit,
  getVerticalAddresses as getVerticalAddressesBit,
  getAddressById as getAddressByIdBit
} from '../bitSagas/address';
import { actions as addressActions } from '../reducers/address';
import { commonActions } from '../reducers/common';

/**
 * This is a generator function that calls getAddress API and returns response
 * @param {*} input Input to retrieve address from API
 * @returns Response of getAddress API
 */
export function* getAddresses(input) {
  // Create an object called reduxUpdate with two properties:
  // successUpdate and errorUpdate
  const reduxUpdate = {
    successUpdate: addressActions.getAddressDataSuccess,
    errorUpdate: addressActions.getAddressFail,
  };

  // Create an object called getAddressesParams by spreading the properties
  // of the input parameter into a new object and adding a property called
  // reduxUpdate
  const getAddressesParams = {
    ...input,
    reduxUpdate,
  };

  // Initialize a variable called response to null
  let response = null;
  try {
    // Call the getAddressesBit function with getAddressesParams as an argument
    // and assign the result to the response variable
    response = yield call(getAddressesBit, getAddressesParams);
  } catch (e) {
    // If an error occurs while calling getAddressesBit, return null
    return null;
  }

  // Return the response variable
  return response;
}


export function* getHorizontalAddresses({normalizeHttpErrors, address}){
  const reduxUpdate = {
    successUpdate: addressActions.setHorizontalAddresses,
  };

  const getAddressesParams = {
    address,
    normalizeHttpErrors,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(getHorizontalAddressesBit, getAddressesParams);
  } catch (e) {
    return null;
  }

  return response;
}

export function* getVerticalAddresses({normalizeHttpErrors, address, id}){
  const reduxUpdate = {
    successUpdate: addressActions.setVerticalAddresses,
  };

  const getAddressesParams = {
    address,
    id,
    normalizeHttpErrors,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(getVerticalAddressesBit, getAddressesParams);
  } catch (e) {
    return null;
  }

  return response;
}

export function* getShippingAddressById({normalizeHttpErrors, payload}){
  const reduxUpdate = {
    successUpdate: commonActions.setShippingAddressName,
  };
  const { locationId } = payload;

  const getAddressesParams = {
    id: locationId,
    normalizeHttpErrors,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(getAddressByIdBit, getAddressesParams);
  } catch (e) {
    return null;
  }

  return response;
}

export function* getPermanentResidenceAddressById({normalizeHttpErrors, payload}){
  const reduxUpdate = {
    successUpdate: commonActions.setPermanentResidenceAddressName,
  };
  const { id } = payload;

  const getAddressesParams = {
    id,
    normalizeHttpErrors,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(getAddressByIdBit, getAddressesParams);
  } catch (e) {
    return null;
  }

  return response;
}

export function* getInstallationAddressById({normalizeHttpErrors, payload}){
  const reduxUpdate = {
    successUpdate: commonActions.setInstallationAddressName,
  };
  const { installationAddress } = payload;

  const getAddressesParams = {
    id: installationAddress.locationId,
    normalizeHttpErrors,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(getAddressByIdBit, getAddressesParams);
  } catch (e) {
    return null;
  }

  return response;
}